import { AsyncPipe } from '@angular/common';
import { Component, OnInit, inject, viewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ColDef } from 'ag-grid-community/dist/lib/entities/colDef';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { BaseComponent, FormService, GridComponent, GridService, NotificationService } from '../../../../tms-shared';
import { RoleService } from '../../services';
import { RoleDocument } from '../../models';

@Component({
  selector: 'app-role-documents',
  templateUrl: './role-documents.component.html',
  styleUrl: './role-documents.component.scss',
  imports: [GridComponent, AsyncPipe],
})
export class RoleDocumentsComponent extends BaseComponent implements OnInit {
  private readonly roleService = inject(RoleService);
  private readonly gridService = inject(GridService);
  private readonly formService = inject(FormService);
  private readonly notificationService = inject(NotificationService);
  private readonly route = inject(ActivatedRoute);

  private readonly grid = viewChild(GridComponent);

  protected columnDefs: ColDef[] = [
    ...this.gridService.checkboxRowSelect('description', $localize`Label`),
    this.gridService.text('key', $localize`Key`),
  ];

  protected rowData$: Observable<RoleDocument[]>;

  private roleId: string;

  ngOnInit(): void {
    this.roleId = this.route.snapshot.paramMap.get('id');
    this.getModel();
  }

  save() {
    this.formService.beginSave();
    this.roleService
      .updateRoleDocuments(
        this.roleId,
        this.grid().selectedRows.map((x: RoleDocument) => x.id),
      )
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: () => {
          this.notificationService.saveSuccess($localize`Role Labels`);
          this.getModel();
          this.formService.endSave(false);
        },
        error: () => {
          this.notificationService.saveFail($localize`Role Labels`);
          this.formService.endSave(true);
        },
      });
  }

  private getModel() {
    this.rowData$ = this.roleService.getRoleDocuments(this.roleId);
    this.grid()?.resetEdited();
  }
}
